// extracted by mini-css-extract-plugin
export default {"range-separator":"range-separator_LrgUy"};